import { Box, withStyles } from '@material-ui/core';

const tempLg = 1400;

export const WrapperBox = withStyles(({ breakpoints }) => ({
  root: {
    [breakpoints.up(tempLg)]: {
      display: 'flex',
      flexDirection: 'row-reverse',
    },
  },
}))(Box);

export const ChartWrapperBox = withStyles(({ spacing }) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexGrow: 1,
    marginRight: spacing(2),
    minHeight: 300,
    overflowX: 'auto',
  },
}))(Box);

export const ChartInnerBox = withStyles(({ spacing, breakpoints }) => ({
  root: {
    width: '100%',
    minWidth: 500,
    padding: spacing(3, 0, 0, 0),
    [breakpoints.up(tempLg)]: {
      padding: spacing(1, 2, 0, 0),
    },
  },
}))(Box);

export const ButtonsBox = withStyles(({ palette, spacing, breakpoints }) => ({
  root: {
    borderRadius: spacing(1),
    background: palette.grey[100],
    display: 'block',
    [breakpoints.up('sm')]: {
      background: palette.grey[100],
      display: 'flex',
    },
    [breakpoints.up(tempLg)]: {
      width: 320,
      display: 'block',
    },
  },
}))(Box);
